import React from "react";


export default function Button({
children,
variant = "primary",
className="",
size = "md",
onClick,
...props
}) {

return (
<button
className={`btn btn-${variant} btn-${size} ${className || ''}`}
onClick={onClick}
{...props}
>
{children}
</button>
);

}